export default __webpack_public_path__ + "static/media/0x7dff46370e9ea5f0bad3c4e29711ad50062ea7a4.2110383f.webp";